/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-63ed8f4f.js';
import '@carbon/icon-helpers';
import 'prop-types';
import React from 'react';

var didWarnAboutDeprecation = {};

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
});

var ChartSpiral32 = /*#__PURE__*/React.forwardRef(function ChartSpiral32(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, children);
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
});

var ChartSpiral24 = /*#__PURE__*/React.forwardRef(function ChartSpiral24(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref4, children);
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
});

var ChartSpiral20 = /*#__PURE__*/React.forwardRef(function ChartSpiral20(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref6, children);
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
});

var ChartSpiral16 = /*#__PURE__*/React.forwardRef(function ChartSpiral16(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref8, children);
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
});

var ChartStacked32 = /*#__PURE__*/React.forwardRef(function ChartStacked32(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref10, children);
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
});

var ChartStacked24 = /*#__PURE__*/React.forwardRef(function ChartStacked24(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref12, children);
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
});

var ChartStacked20 = /*#__PURE__*/React.forwardRef(function ChartStacked20(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref14, children);
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
});

var ChartStacked16 = /*#__PURE__*/React.forwardRef(function ChartStacked16(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref16, children);
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
});

var ChartStepper32 = /*#__PURE__*/React.forwardRef(function ChartStepper32(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref18, children);
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
});

var ChartStepper24 = /*#__PURE__*/React.forwardRef(function ChartStepper24(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref20, children);
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
});

var ChartStepper20 = /*#__PURE__*/React.forwardRef(function ChartStepper20(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref22, children);
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
});

var ChartStepper16 = /*#__PURE__*/React.forwardRef(function ChartStepper16(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref24, children);
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
});

var ChartSunburst32 = /*#__PURE__*/React.forwardRef(function ChartSunburst32(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref26, children);
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
});

var ChartSunburst24 = /*#__PURE__*/React.forwardRef(function ChartSunburst24(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref28, children);
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
});

var ChartSunburst20 = /*#__PURE__*/React.forwardRef(function ChartSunburst20(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref30, children);
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
});

var ChartSunburst16 = /*#__PURE__*/React.forwardRef(function ChartSunburst16(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref32, children);
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "20",
  r: "2"
});

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "4",
  r: "2"
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "6",
  r: "2"
});

var _ref39 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "10",
  r: "2"
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "12",
  r: "2"
});

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "22",
  r: "2"
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "26",
  cy: "28",
  r: "2"
});

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "26",
  r: "2"
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "20",
  r: "2"
});

var _ref45 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "4",
  r: "2"
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "24",
  r: "2"
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "16",
  r: "2"
});

var ChartTSne32 = /*#__PURE__*/React.forwardRef(function ChartTSne32(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, children);
});

var _ref49 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "20",
  r: "2"
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref51 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "4",
  r: "2"
});

var _ref53 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "6",
  r: "2"
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "10",
  r: "2"
});

var _ref55 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "12",
  r: "2"
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "22",
  r: "2"
});

var _ref57 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "26",
  cy: "28",
  r: "2"
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "26",
  r: "2"
});

var _ref59 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "20",
  r: "2"
});

var _ref60 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "4",
  r: "2"
});

var _ref61 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "24",
  r: "2"
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "16",
  r: "2"
});

var ChartTSne24 = /*#__PURE__*/React.forwardRef(function ChartTSne24(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, children);
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "20",
  r: "2"
});

var _ref65 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref66 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref67 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "4",
  r: "2"
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "6",
  r: "2"
});

var _ref69 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "10",
  r: "2"
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "12",
  r: "2"
});

var _ref71 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "22",
  r: "2"
});

var _ref72 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "26",
  cy: "28",
  r: "2"
});

var _ref73 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "26",
  r: "2"
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "20",
  r: "2"
});

var _ref75 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "4",
  r: "2"
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "24",
  r: "2"
});

var _ref77 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "16",
  r: "2"
});

var ChartTSne20 = /*#__PURE__*/React.forwardRef(function ChartTSne20(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, children);
});

var _ref79 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "20",
  r: "2"
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref81 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "4",
  r: "2"
});

var _ref83 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "6",
  r: "2"
});

var _ref84 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "10",
  r: "2"
});

var _ref85 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "12",
  r: "2"
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "22",
  r: "2"
});

var _ref87 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "26",
  cy: "28",
  r: "2"
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "26",
  r: "2"
});

var _ref89 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "20",
  r: "2"
});

var _ref90 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "4",
  r: "2"
});

var _ref91 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "24",
  r: "2"
});

var _ref92 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "4",
  cy: "16",
  r: "2"
});

var ChartTSne16 = /*#__PURE__*/React.forwardRef(function ChartTSne16(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, children);
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
});

var ChartTreemap32 = /*#__PURE__*/React.forwardRef(function ChartTreemap32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref94, children);
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
});

var ChartTreemap24 = /*#__PURE__*/React.forwardRef(function ChartTreemap24(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref96, children);
});

var _ref98 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
});

var ChartTreemap20 = /*#__PURE__*/React.forwardRef(function ChartTreemap20(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref98, children);
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
});

var ChartTreemap16 = /*#__PURE__*/React.forwardRef(function ChartTreemap16(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref100, children);
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
});

var ChartVennDiagram32 = /*#__PURE__*/React.forwardRef(function ChartVennDiagram32(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref102, children);
});

var _ref104 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
});

var ChartVennDiagram24 = /*#__PURE__*/React.forwardRef(function ChartVennDiagram24(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref104, children);
});

var _ref106 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
});

var ChartVennDiagram20 = /*#__PURE__*/React.forwardRef(function ChartVennDiagram20(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref106, children);
});

var _ref108 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
});

var ChartVennDiagram16 = /*#__PURE__*/React.forwardRef(function ChartVennDiagram16(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref108, children);
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
});

var _ref111 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
});

var ChartViolinPlot32 = /*#__PURE__*/React.forwardRef(function ChartViolinPlot32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref110, _ref111, children);
});

var _ref113 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
});

var ChartViolinPlot24 = /*#__PURE__*/React.forwardRef(function ChartViolinPlot24(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref113, _ref114, children);
});

var _ref116 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
});

var _ref117 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
});

var ChartViolinPlot20 = /*#__PURE__*/React.forwardRef(function ChartViolinPlot20(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref116, _ref117, children);
});

var _ref119 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
});

var _ref120 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.86 7.8232L13 4.7231V2H11V4.7231l-1.86 3.1A7.9986 7.9986 0 008 11.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V19.2769l1.86-3.1A7.9986 7.9986 0 0016 12.061v-.122A7.9961 7.9961 0 0014.86 7.8232zM12 6.9434l1.145 1.9087A6.0027 6.0027 0 0113.9185 11h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0110.0815 13h3.837a6.0086 6.0086 0 01-.7735 2.1484zM27.86 11.8232L26 8.7231V2H24V8.7231l-1.86 3.1A7.9986 7.9986 0 0021 15.939v.122a7.9961 7.9961 0 001.14 4.1158l1.86 3.1V26h2V23.2769l1.86-3.1A7.9986 7.9986 0 0029 16.061v-.122A7.9961 7.9961 0 0027.86 11.8232zm-2.86-.88l1.145 1.9087A6.0027 6.0027 0 0126.9185 15h-3.837a6.0086 6.0086 0 01.7735-2.1484zm0 10.1132l-1.145-1.9087A6.0027 6.0027 0 0123.0815 17h3.837a6.0086 6.0086 0 01-.7735 2.1484z"
});

var ChartViolinPlot16 = /*#__PURE__*/React.forwardRef(function ChartViolinPlot16(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref119, _ref120, children);
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var _ref123 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H16V18H14z"
});

var ChartWaterfall32 = /*#__PURE__*/React.forwardRef(function ChartWaterfall32(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref122, _ref123, children);
});

var _ref125 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H16V18H14z"
});

var ChartWaterfall24 = /*#__PURE__*/React.forwardRef(function ChartWaterfall24(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref125, _ref126, children);
});

var _ref128 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var _ref129 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H16V18H14z"
});

var ChartWaterfall20 = /*#__PURE__*/React.forwardRef(function ChartWaterfall20(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref128, _ref129, children);
});

var _ref131 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var _ref132 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H16V18H14z"
});

var ChartWaterfall16 = /*#__PURE__*/React.forwardRef(function ChartWaterfall16(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref131, _ref132, children);
});

var _ref134 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
});

var ChartWinLoss32 = /*#__PURE__*/React.forwardRef(function ChartWinLoss32(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref134, children);
});

var _ref136 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
});

var ChartWinLoss24 = /*#__PURE__*/React.forwardRef(function ChartWinLoss24(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref136, children);
});

var _ref138 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
});

var ChartWinLoss20 = /*#__PURE__*/React.forwardRef(function ChartWinLoss20(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref138, children);
});

var _ref140 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
});

var ChartWinLoss16 = /*#__PURE__*/React.forwardRef(function ChartWinLoss16(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref140, children);
});

var _ref142 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
});

var _ref143 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H24V12H8zM8 16H18V18H8z"
});

var Chat32 = /*#__PURE__*/React.forwardRef(function Chat32(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref142, _ref143, children);
});

var _ref145 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
});

var _ref146 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H24V12H8zM8 16H18V18H8z"
});

var Chat24 = /*#__PURE__*/React.forwardRef(function Chat24(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref145, _ref146, children);
});

var _ref148 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
});

var _ref149 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H24V12H8zM8 16H18V18H8z"
});

var Chat20 = /*#__PURE__*/React.forwardRef(function Chat20(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref148, _ref149, children);
});

var _ref151 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H24V12H8zM8 16H18V18H8z"
});

var Chat16 = /*#__PURE__*/React.forwardRef(function Chat16(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref151, _ref152, children);
});

var _ref154 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
});

var _ref155 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ChatBot32 = /*#__PURE__*/React.forwardRef(function ChatBot32(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref154, _ref155, children);
});

var _ref157 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ChatBot24 = /*#__PURE__*/React.forwardRef(function ChatBot24(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref157, _ref158, children);
});

var _ref160 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
});

var _ref161 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ChatBot20 = /*#__PURE__*/React.forwardRef(function ChatBot20(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref160, _ref161, children);
});

var _ref163 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ChatBot16 = /*#__PURE__*/React.forwardRef(function ChatBot16(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref163, _ref164, children);
});

var _ref166 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox32 = /*#__PURE__*/React.forwardRef(function Checkbox32(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref166, children);
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox24 = /*#__PURE__*/React.forwardRef(function Checkbox24(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref168, children);
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox20 = /*#__PURE__*/React.forwardRef(function Checkbox20(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref170, children);
});

var _ref172 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox16 = /*#__PURE__*/React.forwardRef(function Checkbox16(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref172, children);
});

var _ref174 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref175 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked32 = /*#__PURE__*/React.forwardRef(function CheckboxChecked32(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref174, _ref175, children);
});

var _ref177 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref178 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked24 = /*#__PURE__*/React.forwardRef(function CheckboxChecked24(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref177, _ref178, children);
});

var _ref180 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref181 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked20 = /*#__PURE__*/React.forwardRef(function CheckboxChecked20(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref180, _ref181, children);
});

var _ref183 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked16 = /*#__PURE__*/React.forwardRef(function CheckboxChecked16(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref183, _ref184, children);
});

var _ref186 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref187 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled32 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled32(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref186, _ref187, children);
});

var _ref189 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled24 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled24(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref189, _ref190, children);
});

var _ref192 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref193 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled20 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled20(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref192, _ref193, children);
});

var _ref195 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref196 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled16 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled16(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref195, _ref196, children);
});

var _ref198 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref199 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate32 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref198, _ref199, children);
});

var _ref201 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref202 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate24 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate24(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref201, _ref202, children);
});

var _ref204 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref205 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate20 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate20(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref204, _ref205, children);
});

var _ref207 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref208 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate16 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate16(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref207, _ref208, children);
});

var _ref210 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref211 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled32 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled32(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref210, _ref211, children);
});

var _ref213 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref214 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled24 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled24(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref213, _ref214, children);
});

var _ref216 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref217 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled20 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled20(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref216, _ref217, children);
});

var _ref219 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref220 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled16 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled16(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref219, _ref220, children);
});

var _ref222 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref223 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate32 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate32(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate32']) {
      didWarnAboutDeprecation['CheckboxUndeterminate32'] = true;
      console.warn("The CheckboxUndeterminate32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref222, _ref223, children);
});

var _ref225 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref226 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate24 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate24(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate24']) {
      didWarnAboutDeprecation['CheckboxUndeterminate24'] = true;
      console.warn("The CheckboxUndeterminate24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref225, _ref226, children);
});

var _ref228 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref229 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate20 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate20(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate20']) {
      didWarnAboutDeprecation['CheckboxUndeterminate20'] = true;
      console.warn("The CheckboxUndeterminate20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref228, _ref229, children);
});

var _ref231 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref232 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate16 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate16(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate16']) {
      didWarnAboutDeprecation['CheckboxUndeterminate16'] = true;
      console.warn("The CheckboxUndeterminate16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref231, _ref232, children);
});

var _ref234 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled32 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled32']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled32'] = true;
      console.warn("The CheckboxUndeterminateFilled32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref234, children);
});

var _ref236 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled24 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled24(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled24']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled24'] = true;
      console.warn("The CheckboxUndeterminateFilled24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref236, children);
});

var _ref238 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled20 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled20(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled20']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled20'] = true;
      console.warn("The CheckboxUndeterminateFilled20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref238, children);
});

var _ref240 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled16 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled16(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled16']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled16'] = true;
      console.warn("The CheckboxUndeterminateFilled16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref240, children);
});

var _ref242 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
});

var Checkmark32 = /*#__PURE__*/React.forwardRef(function Checkmark32(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref242, children);
});

var _ref244 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
});

var Checkmark24 = /*#__PURE__*/React.forwardRef(function Checkmark24(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref244, children);
});

var _ref246 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
});

var _ref247 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
});

var Checkmark20 = /*#__PURE__*/React.forwardRef(function Checkmark20(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref246, _ref247, children);
});

var _ref249 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
});

var Checkmark16 = /*#__PURE__*/React.forwardRef(function Checkmark16(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref249, children);
});

var _ref251 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
});

var _ref252 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
  "data-icon-path": "inner-path"
});

var CheckmarkFilled32 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled32(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref251, _ref252, children);
});

var _ref254 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
});

var _ref255 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CheckmarkFilled24 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled24(_ref253, ref) {
  var children = _ref253.children,
      rest = _objectWithoutProperties(_ref253, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref254, _ref255, children);
});

var _ref257 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
});

var _ref258 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CheckmarkFilled20 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled20(_ref256, ref) {
  var children = _ref256.children,
      rest = _objectWithoutProperties(_ref256, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref257, _ref258, children);
});

var _ref260 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
});

var _ref261 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CheckmarkFilled16 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled16(_ref259, ref) {
  var children = _ref259.children,
      rest = _objectWithoutProperties(_ref259, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref260, _ref261, children);
});

var _ref263 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref264 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref265 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError32 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError32(_ref262, ref) {
  var children = _ref262.children,
      rest = _objectWithoutProperties(_ref262, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref263, _ref264, _ref265, children);
});

var _ref267 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref269 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError24 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError24(_ref266, ref) {
  var children = _ref266.children,
      rest = _objectWithoutProperties(_ref266, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref267, _ref268, _ref269, children);
});

var _ref271 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref272 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref273 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError20 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError20(_ref270, ref) {
  var children = _ref270.children,
      rest = _objectWithoutProperties(_ref270, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref271, _ref272, _ref273, children);
});

var _ref275 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref276 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref277 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError16 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError16(_ref274, ref) {
  var children = _ref274.children,
      rest = _objectWithoutProperties(_ref274, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref275, _ref276, _ref277, children);
});

var _ref279 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref280 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref281 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning32 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning32(_ref278, ref) {
  var children = _ref278.children,
      rest = _objectWithoutProperties(_ref278, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref279, _ref280, _ref281, children);
});

var _ref283 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref284 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref285 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning24 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning24(_ref282, ref) {
  var children = _ref282.children,
      rest = _objectWithoutProperties(_ref282, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref283, _ref284, _ref285, children);
});

var _ref287 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref288 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref289 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning20 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning20(_ref286, ref) {
  var children = _ref286.children,
      rest = _objectWithoutProperties(_ref286, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref287, _ref288, _ref289, children);
});

var _ref291 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref293 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning16 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning16(_ref290, ref) {
  var children = _ref290.children,
      rest = _objectWithoutProperties(_ref290, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref291, _ref292, _ref293, children);
});

var _ref295 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref296 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline32 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline32(_ref294, ref) {
  var children = _ref294.children,
      rest = _objectWithoutProperties(_ref294, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref295, _ref296, children);
});

var _ref298 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref299 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline24 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline24(_ref297, ref) {
  var children = _ref297.children,
      rest = _objectWithoutProperties(_ref297, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref298, _ref299, children);
});

var _ref301 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref302 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline20 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline20(_ref300, ref) {
  var children = _ref300.children,
      rest = _objectWithoutProperties(_ref300, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref301, _ref302, children);
});

var _ref304 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref305 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline16 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline16(_ref303, ref) {
  var children = _ref303.children,
      rest = _objectWithoutProperties(_ref303, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref304, _ref305, children);
});

var _ref307 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref308 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError32 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError32(_ref306, ref) {
  var children = _ref306.children,
      rest = _objectWithoutProperties(_ref306, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref307, _ref308, children);
});

var _ref310 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref311 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError24 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError24(_ref309, ref) {
  var children = _ref309.children,
      rest = _objectWithoutProperties(_ref309, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref310, _ref311, children);
});

var _ref313 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref314 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError20 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError20(_ref312, ref) {
  var children = _ref312.children,
      rest = _objectWithoutProperties(_ref312, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref313, _ref314, children);
});

var _ref316 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref317 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError16 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError16(_ref315, ref) {
  var children = _ref315.children,
      rest = _objectWithoutProperties(_ref315, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref316, _ref317, children);
});

var _ref319 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref320 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning32 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning32(_ref318, ref) {
  var children = _ref318.children,
      rest = _objectWithoutProperties(_ref318, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref319, _ref320, children);
});

var _ref322 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref323 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning24 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning24(_ref321, ref) {
  var children = _ref321.children,
      rest = _objectWithoutProperties(_ref321, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref322, _ref323, children);
});

var _ref325 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning20 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning20(_ref324, ref) {
  var children = _ref324.children,
      rest = _objectWithoutProperties(_ref324, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref325, _ref326, children);
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref329 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning16 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning16(_ref327, ref) {
  var children = _ref327.children,
      rest = _objectWithoutProperties(_ref327, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref328, _ref329, children);
});

var _ref331 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry32 = /*#__PURE__*/React.forwardRef(function Chemistry32(_ref330, ref) {
  var children = _ref330.children,
      rest = _objectWithoutProperties(_ref330, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref331, children);
});

var _ref333 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry24 = /*#__PURE__*/React.forwardRef(function Chemistry24(_ref332, ref) {
  var children = _ref332.children,
      rest = _objectWithoutProperties(_ref332, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref333, children);
});

var _ref335 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry20 = /*#__PURE__*/React.forwardRef(function Chemistry20(_ref334, ref) {
  var children = _ref334.children,
      rest = _objectWithoutProperties(_ref334, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref335, children);
});

var _ref337 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry16 = /*#__PURE__*/React.forwardRef(function Chemistry16(_ref336, ref) {
  var children = _ref336.children,
      rest = _objectWithoutProperties(_ref336, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref337, children);
});

var _ref339 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference32 = /*#__PURE__*/React.forwardRef(function ChemistryReference32(_ref338, ref) {
  var children = _ref338.children,
      rest = _objectWithoutProperties(_ref338, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref339, _ref340, children);
});

var _ref342 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref343 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference24 = /*#__PURE__*/React.forwardRef(function ChemistryReference24(_ref341, ref) {
  var children = _ref341.children,
      rest = _objectWithoutProperties(_ref341, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref342, _ref343, children);
});

var _ref345 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference20 = /*#__PURE__*/React.forwardRef(function ChemistryReference20(_ref344, ref) {
  var children = _ref344.children,
      rest = _objectWithoutProperties(_ref344, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref345, _ref346, children);
});

var _ref348 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref349 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference16 = /*#__PURE__*/React.forwardRef(function ChemistryReference16(_ref347, ref) {
  var children = _ref347.children,
      rest = _objectWithoutProperties(_ref347, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref348, _ref349, children);
});

var _ref351 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
});

var ChevronDown32 = /*#__PURE__*/React.forwardRef(function ChevronDown32(_ref350, ref) {
  var children = _ref350.children,
      rest = _objectWithoutProperties(_ref350, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref351, children);
});

var _ref353 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
});

var ChevronDown24 = /*#__PURE__*/React.forwardRef(function ChevronDown24(_ref352, ref) {
  var children = _ref352.children,
      rest = _objectWithoutProperties(_ref352, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref353, children);
});

var _ref355 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
});

var ChevronDown20 = /*#__PURE__*/React.forwardRef(function ChevronDown20(_ref354, ref) {
  var children = _ref354.children,
      rest = _objectWithoutProperties(_ref354, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref355, children);
});

var _ref357 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
});

var ChevronDown16 = /*#__PURE__*/React.forwardRef(function ChevronDown16(_ref356, ref) {
  var children = _ref356.children,
      rest = _objectWithoutProperties(_ref356, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref357, children);
});

var _ref359 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
});

var ChevronDownGlyph = /*#__PURE__*/React.forwardRef(function ChevronDownGlyph(_ref358, ref) {
  var children = _ref358.children,
      rest = _objectWithoutProperties(_ref358, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref359, children);
});

var _ref361 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
});

var ChevronLeft32 = /*#__PURE__*/React.forwardRef(function ChevronLeft32(_ref360, ref) {
  var children = _ref360.children,
      rest = _objectWithoutProperties(_ref360, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref361, children);
});

var _ref363 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
});

var ChevronLeft24 = /*#__PURE__*/React.forwardRef(function ChevronLeft24(_ref362, ref) {
  var children = _ref362.children,
      rest = _objectWithoutProperties(_ref362, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref363, children);
});

var _ref365 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
});

var ChevronLeft20 = /*#__PURE__*/React.forwardRef(function ChevronLeft20(_ref364, ref) {
  var children = _ref364.children,
      rest = _objectWithoutProperties(_ref364, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref365, children);
});

var _ref367 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
});

var ChevronLeft16 = /*#__PURE__*/React.forwardRef(function ChevronLeft16(_ref366, ref) {
  var children = _ref366.children,
      rest = _objectWithoutProperties(_ref366, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref367, children);
});

var _ref369 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
});

var ChevronLeftGlyph = /*#__PURE__*/React.forwardRef(function ChevronLeftGlyph(_ref368, ref) {
  var children = _ref368.children,
      rest = _objectWithoutProperties(_ref368, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref369, children);
});

var _ref371 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 19L31 31 19 31 31 19z"
});

var ChevronMini32 = /*#__PURE__*/React.forwardRef(function ChevronMini32(_ref370, ref) {
  var children = _ref370.children,
      rest = _objectWithoutProperties(_ref370, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref371, children);
});

var _ref373 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 19L31 31 19 31 31 19z"
});

var ChevronMini24 = /*#__PURE__*/React.forwardRef(function ChevronMini24(_ref372, ref) {
  var children = _ref372.children,
      rest = _objectWithoutProperties(_ref372, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref373, children);
});

var _ref375 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 19L31 31 19 31 31 19z"
});

var ChevronMini20 = /*#__PURE__*/React.forwardRef(function ChevronMini20(_ref374, ref) {
  var children = _ref374.children,
      rest = _objectWithoutProperties(_ref374, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref375, children);
});

var _ref377 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 9L15 15 9 15z"
});

var ChevronMini16 = /*#__PURE__*/React.forwardRef(function ChevronMini16(_ref376, ref) {
  var children = _ref376.children,
      rest = _objectWithoutProperties(_ref376, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref377, children);
});

var _ref379 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
});

var ChevronRight32 = /*#__PURE__*/React.forwardRef(function ChevronRight32(_ref378, ref) {
  var children = _ref378.children,
      rest = _objectWithoutProperties(_ref378, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref379, children);
});

var _ref381 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
});

var ChevronRight24 = /*#__PURE__*/React.forwardRef(function ChevronRight24(_ref380, ref) {
  var children = _ref380.children,
      rest = _objectWithoutProperties(_ref380, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref381, children);
});

var _ref383 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
});

var ChevronRight20 = /*#__PURE__*/React.forwardRef(function ChevronRight20(_ref382, ref) {
  var children = _ref382.children,
      rest = _objectWithoutProperties(_ref382, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref383, children);
});

var _ref385 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
});

var ChevronRight16 = /*#__PURE__*/React.forwardRef(function ChevronRight16(_ref384, ref) {
  var children = _ref384.children,
      rest = _objectWithoutProperties(_ref384, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref385, children);
});

var _ref387 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
});

var ChevronRightGlyph = /*#__PURE__*/React.forwardRef(function ChevronRightGlyph(_ref386, ref) {
  var children = _ref386.children,
      rest = _objectWithoutProperties(_ref386, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref387, children);
});

var _ref389 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
});

var ChevronSort32 = /*#__PURE__*/React.forwardRef(function ChevronSort32(_ref388, ref) {
  var children = _ref388.children,
      rest = _objectWithoutProperties(_ref388, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref389, children);
});

var _ref391 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
});

var ChevronSort24 = /*#__PURE__*/React.forwardRef(function ChevronSort24(_ref390, ref) {
  var children = _ref390.children,
      rest = _objectWithoutProperties(_ref390, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref391, children);
});

var _ref393 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
});

var ChevronSort20 = /*#__PURE__*/React.forwardRef(function ChevronSort20(_ref392, ref) {
  var children = _ref392.children,
      rest = _objectWithoutProperties(_ref392, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref393, children);
});

var _ref395 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
});

var ChevronSort16 = /*#__PURE__*/React.forwardRef(function ChevronSort16(_ref394, ref) {
  var children = _ref394.children,
      rest = _objectWithoutProperties(_ref394, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref395, children);
});

var _ref397 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
});

var ChevronSortDown32 = /*#__PURE__*/React.forwardRef(function ChevronSortDown32(_ref396, ref) {
  var children = _ref396.children,
      rest = _objectWithoutProperties(_ref396, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref397, children);
});

var _ref399 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
});

var ChevronSortDown24 = /*#__PURE__*/React.forwardRef(function ChevronSortDown24(_ref398, ref) {
  var children = _ref398.children,
      rest = _objectWithoutProperties(_ref398, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref399, children);
});

var _ref401 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
});

var ChevronSortDown20 = /*#__PURE__*/React.forwardRef(function ChevronSortDown20(_ref400, ref) {
  var children = _ref400.children,
      rest = _objectWithoutProperties(_ref400, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref401, children);
});

var _ref403 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
});

var ChevronSortDown16 = /*#__PURE__*/React.forwardRef(function ChevronSortDown16(_ref402, ref) {
  var children = _ref402.children,
      rest = _objectWithoutProperties(_ref402, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref403, children);
});

var _ref405 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
});

var ChevronSortUp32 = /*#__PURE__*/React.forwardRef(function ChevronSortUp32(_ref404, ref) {
  var children = _ref404.children,
      rest = _objectWithoutProperties(_ref404, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref405, children);
});

var _ref407 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
});

var ChevronSortUp24 = /*#__PURE__*/React.forwardRef(function ChevronSortUp24(_ref406, ref) {
  var children = _ref406.children,
      rest = _objectWithoutProperties(_ref406, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref407, children);
});

var _ref409 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
});

var ChevronSortUp20 = /*#__PURE__*/React.forwardRef(function ChevronSortUp20(_ref408, ref) {
  var children = _ref408.children,
      rest = _objectWithoutProperties(_ref408, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref409, children);
});

var _ref411 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
});

var ChevronSortUp16 = /*#__PURE__*/React.forwardRef(function ChevronSortUp16(_ref410, ref) {
  var children = _ref410.children,
      rest = _objectWithoutProperties(_ref410, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref411, children);
});

var _ref413 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
});

var ChevronUp32 = /*#__PURE__*/React.forwardRef(function ChevronUp32(_ref412, ref) {
  var children = _ref412.children,
      rest = _objectWithoutProperties(_ref412, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref413, children);
});

var _ref415 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
});

var ChevronUp24 = /*#__PURE__*/React.forwardRef(function ChevronUp24(_ref414, ref) {
  var children = _ref414.children,
      rest = _objectWithoutProperties(_ref414, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref415, children);
});

var _ref417 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
});

var ChevronUp20 = /*#__PURE__*/React.forwardRef(function ChevronUp20(_ref416, ref) {
  var children = _ref416.children,
      rest = _objectWithoutProperties(_ref416, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref417, children);
});

var _ref419 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
});

var ChevronUp16 = /*#__PURE__*/React.forwardRef(function ChevronUp16(_ref418, ref) {
  var children = _ref418.children,
      rest = _objectWithoutProperties(_ref418, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref419, children);
});

var _ref421 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
});

var ChevronUpGlyph = /*#__PURE__*/React.forwardRef(function ChevronUpGlyph(_ref420, ref) {
  var children = _ref420.children,
      rest = _objectWithoutProperties(_ref420, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref421, children);
});

var _ref423 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip32 = /*#__PURE__*/React.forwardRef(function Chip32(_ref422, ref) {
  var children = _ref422.children,
      rest = _objectWithoutProperties(_ref422, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref423, _ref424, children);
});

var _ref426 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref427 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip24 = /*#__PURE__*/React.forwardRef(function Chip24(_ref425, ref) {
  var children = _ref425.children,
      rest = _objectWithoutProperties(_ref425, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref426, _ref427, children);
});

var _ref429 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip20 = /*#__PURE__*/React.forwardRef(function Chip20(_ref428, ref) {
  var children = _ref428.children,
      rest = _objectWithoutProperties(_ref428, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref429, _ref430, children);
});

var _ref432 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref433 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip16 = /*#__PURE__*/React.forwardRef(function Chip16(_ref431, ref) {
  var children = _ref431.children,
      rest = _objectWithoutProperties(_ref431, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref432, _ref433, children);
});

var _ref435 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
});

var Choices32 = /*#__PURE__*/React.forwardRef(function Choices32(_ref434, ref) {
  var children = _ref434.children,
      rest = _objectWithoutProperties(_ref434, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref435, children);
});

var _ref437 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
});

var Choices24 = /*#__PURE__*/React.forwardRef(function Choices24(_ref436, ref) {
  var children = _ref436.children,
      rest = _objectWithoutProperties(_ref436, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref437, children);
});

var _ref439 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
});

var Choices20 = /*#__PURE__*/React.forwardRef(function Choices20(_ref438, ref) {
  var children = _ref438.children,
      rest = _objectWithoutProperties(_ref438, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref439, children);
});

var _ref441 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
});

var Choices16 = /*#__PURE__*/React.forwardRef(function Choices16(_ref440, ref) {
  var children = _ref440.children,
      rest = _objectWithoutProperties(_ref440, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref441, children);
});

var _ref443 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
});

var ChoroplethMap32 = /*#__PURE__*/React.forwardRef(function ChoroplethMap32(_ref442, ref) {
  var children = _ref442.children,
      rest = _objectWithoutProperties(_ref442, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref443, children);
});

var _ref445 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
});

var ChoroplethMap24 = /*#__PURE__*/React.forwardRef(function ChoroplethMap24(_ref444, ref) {
  var children = _ref444.children,
      rest = _objectWithoutProperties(_ref444, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref445, children);
});

var _ref447 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
});

var ChoroplethMap20 = /*#__PURE__*/React.forwardRef(function ChoroplethMap20(_ref446, ref) {
  var children = _ref446.children,
      rest = _objectWithoutProperties(_ref446, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref447, children);
});

var _ref449 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
});

var ChoroplethMap16 = /*#__PURE__*/React.forwardRef(function ChoroplethMap16(_ref448, ref) {
  var children = _ref448.children,
      rest = _objectWithoutProperties(_ref448, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref449, children);
});

var _ref451 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref452 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled32 = /*#__PURE__*/React.forwardRef(function CircleFilled32(_ref450, ref) {
  var children = _ref450.children,
      rest = _objectWithoutProperties(_ref450, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref451, _ref452, children);
});

var _ref454 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref455 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled24 = /*#__PURE__*/React.forwardRef(function CircleFilled24(_ref453, ref) {
  var children = _ref453.children,
      rest = _objectWithoutProperties(_ref453, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref454, _ref455, children);
});

var _ref457 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref458 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled20 = /*#__PURE__*/React.forwardRef(function CircleFilled20(_ref456, ref) {
  var children = _ref456.children,
      rest = _objectWithoutProperties(_ref456, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref457, _ref458, children);
});

var _ref460 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref461 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled16 = /*#__PURE__*/React.forwardRef(function CircleFilled16(_ref459, ref) {
  var children = _ref459.children,
      rest = _objectWithoutProperties(_ref459, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref460, _ref461, children);
});

var _ref463 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash32 = /*#__PURE__*/React.forwardRef(function CircleDash32(_ref462, ref) {
  var children = _ref462.children,
      rest = _objectWithoutProperties(_ref462, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref463, children);
});

var _ref465 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash24 = /*#__PURE__*/React.forwardRef(function CircleDash24(_ref464, ref) {
  var children = _ref464.children,
      rest = _objectWithoutProperties(_ref464, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref465, children);
});

var _ref467 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash20 = /*#__PURE__*/React.forwardRef(function CircleDash20(_ref466, ref) {
  var children = _ref466.children,
      rest = _objectWithoutProperties(_ref466, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref467, children);
});

var _ref469 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash16 = /*#__PURE__*/React.forwardRef(function CircleDash16(_ref468, ref) {
  var children = _ref468.children,
      rest = _objectWithoutProperties(_ref468, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref469, children);
});

var _ref471 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref472 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement32 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement32(_ref470, ref) {
  var children = _ref470.children,
      rest = _objectWithoutProperties(_ref470, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref471, _ref472, children);
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref475 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement24 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement24(_ref473, ref) {
  var children = _ref473.children,
      rest = _objectWithoutProperties(_ref473, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref474, _ref475, children);
});

var _ref477 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref478 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement20 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement20(_ref476, ref) {
  var children = _ref476.children,
      rest = _objectWithoutProperties(_ref476, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref477, _ref478, children);
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref481 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement16 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement16(_ref479, ref) {
  var children = _ref479.children,
      rest = _objectWithoutProperties(_ref479, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref480, _ref481, children);
});

var _ref483 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking32 = /*#__PURE__*/React.forwardRef(function CirclePacking32(_ref482, ref) {
  var children = _ref482.children,
      rest = _objectWithoutProperties(_ref482, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref483, children);
});

var _ref485 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking24 = /*#__PURE__*/React.forwardRef(function CirclePacking24(_ref484, ref) {
  var children = _ref484.children,
      rest = _objectWithoutProperties(_ref484, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref485, children);
});

var _ref487 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking20 = /*#__PURE__*/React.forwardRef(function CirclePacking20(_ref486, ref) {
  var children = _ref486.children,
      rest = _objectWithoutProperties(_ref486, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref487, children);
});

var _ref489 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking16 = /*#__PURE__*/React.forwardRef(function CirclePacking16(_ref488, ref) {
  var children = _ref488.children,
      rest = _objectWithoutProperties(_ref488, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref489, children);
});

var _ref491 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer32 = /*#__PURE__*/React.forwardRef(function QCircuitComposer32(_ref490, ref) {
  var children = _ref490.children,
      rest = _objectWithoutProperties(_ref490, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref491, _ref492, children);
});

var _ref494 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref495 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer24 = /*#__PURE__*/React.forwardRef(function QCircuitComposer24(_ref493, ref) {
  var children = _ref493.children,
      rest = _objectWithoutProperties(_ref493, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref494, _ref495, children);
});

var _ref497 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer20 = /*#__PURE__*/React.forwardRef(function QCircuitComposer20(_ref496, ref) {
  var children = _ref496.children,
      rest = _objectWithoutProperties(_ref496, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref497, _ref498, children);
});

var _ref500 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref501 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer16 = /*#__PURE__*/React.forwardRef(function QCircuitComposer16(_ref499, ref) {
  var children = _ref499.children,
      rest = _objectWithoutProperties(_ref499, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref500, _ref501, children);
});

var _ref503 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification32 = /*#__PURE__*/React.forwardRef(function Classification32(_ref502, ref) {
  var children = _ref502.children,
      rest = _objectWithoutProperties(_ref502, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref503, _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref507 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification24 = /*#__PURE__*/React.forwardRef(function Classification24(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, _ref507, children);
});

var _ref509 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification20 = /*#__PURE__*/React.forwardRef(function Classification20(_ref508, ref) {
  var children = _ref508.children,
      rest = _objectWithoutProperties(_ref508, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref509, _ref510, children);
});

var _ref512 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref513 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification16 = /*#__PURE__*/React.forwardRef(function Classification16(_ref511, ref) {
  var children = _ref511.children,
      rest = _objectWithoutProperties(_ref511, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref512, _ref513, children);
});

var _ref515 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage32 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage32(_ref514, ref) {
  var children = _ref514.children,
      rest = _objectWithoutProperties(_ref514, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref515, children);
});

var _ref517 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage24 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage24(_ref516, ref) {
  var children = _ref516.children,
      rest = _objectWithoutProperties(_ref516, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref517, children);
});

var _ref519 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage20 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage20(_ref518, ref) {
  var children = _ref518.children,
      rest = _objectWithoutProperties(_ref518, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref519, children);
});

var _ref521 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage16 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage16(_ref520, ref) {
  var children = _ref520.children,
      rest = _objectWithoutProperties(_ref520, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref521, children);
});

var _ref523 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref524 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref525 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref526 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean32 = /*#__PURE__*/React.forwardRef(function Clean32(_ref522, ref) {
  var children = _ref522.children,
      rest = _objectWithoutProperties(_ref522, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref523, _ref524, _ref525, _ref526, children);
});

var _ref528 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref529 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref530 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref531 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean24 = /*#__PURE__*/React.forwardRef(function Clean24(_ref527, ref) {
  var children = _ref527.children,
      rest = _objectWithoutProperties(_ref527, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref528, _ref529, _ref530, _ref531, children);
});

var _ref533 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref534 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref535 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref536 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean20 = /*#__PURE__*/React.forwardRef(function Clean20(_ref532, ref) {
  var children = _ref532.children,
      rest = _objectWithoutProperties(_ref532, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref533, _ref534, _ref535, _ref536, children);
});

var _ref538 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref539 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref540 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref541 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean16 = /*#__PURE__*/React.forwardRef(function Clean16(_ref537, ref) {
  var children = _ref537.children,
      rest = _objectWithoutProperties(_ref537, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref538, _ref539, _ref540, _ref541, children);
});

var _ref543 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close32 = /*#__PURE__*/React.forwardRef(function Close32(_ref542, ref) {
  var children = _ref542.children,
      rest = _objectWithoutProperties(_ref542, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref543, children);
});

var _ref545 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close24 = /*#__PURE__*/React.forwardRef(function Close24(_ref544, ref) {
  var children = _ref544.children,
      rest = _objectWithoutProperties(_ref544, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref545, children);
});

var _ref547 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close20 = /*#__PURE__*/React.forwardRef(function Close20(_ref546, ref) {
  var children = _ref546.children,
      rest = _objectWithoutProperties(_ref546, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref547, children);
});

var _ref549 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close16 = /*#__PURE__*/React.forwardRef(function Close16(_ref548, ref) {
  var children = _ref548.children,
      rest = _objectWithoutProperties(_ref548, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref549, children);
});

var _ref551 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CloseFilled32 = /*#__PURE__*/React.forwardRef(function CloseFilled32(_ref550, ref) {
  var children = _ref550.children,
      rest = _objectWithoutProperties(_ref550, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref551, _ref552, children);
});

var _ref554 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
});

var _ref555 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CloseFilled24 = /*#__PURE__*/React.forwardRef(function CloseFilled24(_ref553, ref) {
  var children = _ref553.children,
      rest = _objectWithoutProperties(_ref553, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref554, _ref555, children);
});

var _ref557 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CloseFilled20 = /*#__PURE__*/React.forwardRef(function CloseFilled20(_ref556, ref) {
  var children = _ref556.children,
      rest = _objectWithoutProperties(_ref556, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref557, _ref558, children);
});

var _ref560 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
});

var CloseFilled16 = /*#__PURE__*/React.forwardRef(function CloseFilled16(_ref559, ref) {
  var children = _ref559.children,
      rest = _objectWithoutProperties(_ref559, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref560, children);
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref563 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline32 = /*#__PURE__*/React.forwardRef(function CloseOutline32(_ref561, ref) {
  var children = _ref561.children,
      rest = _objectWithoutProperties(_ref561, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref562, _ref563, children);
});

var _ref565 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref566 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline24 = /*#__PURE__*/React.forwardRef(function CloseOutline24(_ref564, ref) {
  var children = _ref564.children,
      rest = _objectWithoutProperties(_ref564, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref565, _ref566, children);
});

var _ref568 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref569 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline20 = /*#__PURE__*/React.forwardRef(function CloseOutline20(_ref567, ref) {
  var children = _ref567.children,
      rest = _objectWithoutProperties(_ref567, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref568, _ref569, children);
});

var _ref571 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref572 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline16 = /*#__PURE__*/React.forwardRef(function CloseOutline16(_ref570, ref) {
  var children = _ref570.children,
      rest = _objectWithoutProperties(_ref570, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref571, _ref572, children);
});

var _ref574 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref575 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption32 = /*#__PURE__*/React.forwardRef(function ClosedCaption32(_ref573, ref) {
  var children = _ref573.children,
      rest = _objectWithoutProperties(_ref573, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref574, _ref575, children);
});

var _ref577 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption24 = /*#__PURE__*/React.forwardRef(function ClosedCaption24(_ref576, ref) {
  var children = _ref576.children,
      rest = _objectWithoutProperties(_ref576, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref577, _ref578, children);
});

var _ref580 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref581 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption20 = /*#__PURE__*/React.forwardRef(function ClosedCaption20(_ref579, ref) {
  var children = _ref579.children,
      rest = _objectWithoutProperties(_ref579, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref580, _ref581, children);
});

var _ref583 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref584 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption16 = /*#__PURE__*/React.forwardRef(function ClosedCaption16(_ref582, ref) {
  var children = _ref582.children,
      rest = _objectWithoutProperties(_ref582, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref583, _ref584, children);
});

var _ref586 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref587 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt32 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt32(_ref585, ref) {
  var children = _ref585.children,
      rest = _objectWithoutProperties(_ref585, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref586, _ref587, children);
});

var _ref589 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt24 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt24(_ref588, ref) {
  var children = _ref588.children,
      rest = _objectWithoutProperties(_ref588, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref589, _ref590, children);
});

var _ref592 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref593 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt20 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt20(_ref591, ref) {
  var children = _ref591.children,
      rest = _objectWithoutProperties(_ref591, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref592, _ref593, children);
});

var _ref595 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt16 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt16(_ref594, ref) {
  var children = _ref594.children,
      rest = _objectWithoutProperties(_ref594, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref595, _ref596, children);
});

var _ref598 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled32 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled32(_ref597, ref) {
  var children = _ref597.children,
      rest = _objectWithoutProperties(_ref597, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref598, children);
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled24 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled24(_ref599, ref) {
  var children = _ref599.children,
      rest = _objectWithoutProperties(_ref599, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled20 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled20(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, children);
});

var _ref604 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled16 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled16(_ref603, ref) {
  var children = _ref603.children,
      rest = _objectWithoutProperties(_ref603, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref604, children);
});

var _ref606 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud32 = /*#__PURE__*/React.forwardRef(function Cloud32(_ref605, ref) {
  var children = _ref605.children,
      rest = _objectWithoutProperties(_ref605, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref606, children);
});

var _ref608 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud24 = /*#__PURE__*/React.forwardRef(function Cloud24(_ref607, ref) {
  var children = _ref607.children,
      rest = _objectWithoutProperties(_ref607, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref608, children);
});

var _ref610 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud20 = /*#__PURE__*/React.forwardRef(function Cloud20(_ref609, ref) {
  var children = _ref609.children,
      rest = _objectWithoutProperties(_ref609, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref610, children);
});

var _ref612 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud16 = /*#__PURE__*/React.forwardRef(function Cloud16(_ref611, ref) {
  var children = _ref611.children,
      rest = _objectWithoutProperties(_ref611, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref612, children);
});

var _ref614 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps32 = /*#__PURE__*/React.forwardRef(function CloudDataOps32(_ref613, ref) {
  var children = _ref613.children,
      rest = _objectWithoutProperties(_ref613, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref614, children);
});

var _ref616 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps24 = /*#__PURE__*/React.forwardRef(function CloudDataOps24(_ref615, ref) {
  var children = _ref615.children,
      rest = _objectWithoutProperties(_ref615, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref616, children);
});

var _ref618 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps20 = /*#__PURE__*/React.forwardRef(function CloudDataOps20(_ref617, ref) {
  var children = _ref617.children,
      rest = _objectWithoutProperties(_ref617, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref618, children);
});

var _ref620 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps16 = /*#__PURE__*/React.forwardRef(function CloudDataOps16(_ref619, ref) {
  var children = _ref619.children,
      rest = _objectWithoutProperties(_ref619, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref620, children);
});

var _ref622 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref623 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload32 = /*#__PURE__*/React.forwardRef(function CloudDownload32(_ref621, ref) {
  var children = _ref621.children,
      rest = _objectWithoutProperties(_ref621, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref622, _ref623, children);
});

var _ref625 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref626 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload24 = /*#__PURE__*/React.forwardRef(function CloudDownload24(_ref624, ref) {
  var children = _ref624.children,
      rest = _objectWithoutProperties(_ref624, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref625, _ref626, children);
});

var _ref628 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref629 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload20 = /*#__PURE__*/React.forwardRef(function CloudDownload20(_ref627, ref) {
  var children = _ref627.children,
      rest = _objectWithoutProperties(_ref627, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref628, _ref629, children);
});

var _ref631 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref632 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload16 = /*#__PURE__*/React.forwardRef(function CloudDownload16(_ref630, ref) {
  var children = _ref630.children,
      rest = _objectWithoutProperties(_ref630, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref631, _ref632, children);
});

var _ref634 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning32 = /*#__PURE__*/React.forwardRef(function CloudLightning32(_ref633, ref) {
  var children = _ref633.children,
      rest = _objectWithoutProperties(_ref633, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning32']) {
      didWarnAboutDeprecation['CloudLightning32'] = true;
      console.warn("The CloudLightning32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref634, children);
});

var _ref636 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning24 = /*#__PURE__*/React.forwardRef(function CloudLightning24(_ref635, ref) {
  var children = _ref635.children,
      rest = _objectWithoutProperties(_ref635, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning24']) {
      didWarnAboutDeprecation['CloudLightning24'] = true;
      console.warn("The CloudLightning24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref636, children);
});

var _ref638 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning20 = /*#__PURE__*/React.forwardRef(function CloudLightning20(_ref637, ref) {
  var children = _ref637.children,
      rest = _objectWithoutProperties(_ref637, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning20']) {
      didWarnAboutDeprecation['CloudLightning20'] = true;
      console.warn("The CloudLightning20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref638, children);
});

var _ref640 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning16 = /*#__PURE__*/React.forwardRef(function CloudLightning16(_ref639, ref) {
  var children = _ref639.children,
      rest = _objectWithoutProperties(_ref639, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning16']) {
      didWarnAboutDeprecation['CloudLightning16'] = true;
      console.warn("The CloudLightning16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref640, children);
});

var _ref642 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain32 = /*#__PURE__*/React.forwardRef(function CloudRain32(_ref641, ref) {
  var children = _ref641.children,
      rest = _objectWithoutProperties(_ref641, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain32']) {
      didWarnAboutDeprecation['CloudRain32'] = true;
      console.warn("The CloudRain32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref642, children);
});

var _ref644 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain24 = /*#__PURE__*/React.forwardRef(function CloudRain24(_ref643, ref) {
  var children = _ref643.children,
      rest = _objectWithoutProperties(_ref643, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain24']) {
      didWarnAboutDeprecation['CloudRain24'] = true;
      console.warn("The CloudRain24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref644, children);
});

var _ref646 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain20 = /*#__PURE__*/React.forwardRef(function CloudRain20(_ref645, ref) {
  var children = _ref645.children,
      rest = _objectWithoutProperties(_ref645, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain20']) {
      didWarnAboutDeprecation['CloudRain20'] = true;
      console.warn("The CloudRain20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref646, children);
});

var _ref648 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain16 = /*#__PURE__*/React.forwardRef(function CloudRain16(_ref647, ref) {
  var children = _ref647.children,
      rest = _objectWithoutProperties(_ref647, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain16']) {
      didWarnAboutDeprecation['CloudRain16'] = true;
      console.warn("The CloudRain16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref648, children);
});

var _ref650 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow32 = /*#__PURE__*/React.forwardRef(function CloudSnow32(_ref649, ref) {
  var children = _ref649.children,
      rest = _objectWithoutProperties(_ref649, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow32']) {
      didWarnAboutDeprecation['CloudSnow32'] = true;
      console.warn("The CloudSnow32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref650, children);
});

var _ref652 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow24 = /*#__PURE__*/React.forwardRef(function CloudSnow24(_ref651, ref) {
  var children = _ref651.children,
      rest = _objectWithoutProperties(_ref651, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow24']) {
      didWarnAboutDeprecation['CloudSnow24'] = true;
      console.warn("The CloudSnow24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref652, children);
});

var _ref654 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow20 = /*#__PURE__*/React.forwardRef(function CloudSnow20(_ref653, ref) {
  var children = _ref653.children,
      rest = _objectWithoutProperties(_ref653, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow20']) {
      didWarnAboutDeprecation['CloudSnow20'] = true;
      console.warn("The CloudSnow20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref654, children);
});

var _ref656 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow16 = /*#__PURE__*/React.forwardRef(function CloudSnow16(_ref655, ref) {
  var children = _ref655.children,
      rest = _objectWithoutProperties(_ref655, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow16']) {
      didWarnAboutDeprecation['CloudSnow16'] = true;
      console.warn("The CloudSnow16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref656, children);
});

var _ref658 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref659 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload32 = /*#__PURE__*/React.forwardRef(function CloudUpload32(_ref657, ref) {
  var children = _ref657.children,
      rest = _objectWithoutProperties(_ref657, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref658, _ref659, children);
});

var _ref661 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref662 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload24 = /*#__PURE__*/React.forwardRef(function CloudUpload24(_ref660, ref) {
  var children = _ref660.children,
      rest = _objectWithoutProperties(_ref660, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref661, _ref662, children);
});

var _ref664 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref665 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload20 = /*#__PURE__*/React.forwardRef(function CloudUpload20(_ref663, ref) {
  var children = _ref663.children,
      rest = _objectWithoutProperties(_ref663, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref664, _ref665, children);
});

var _ref667 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref668 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload16 = /*#__PURE__*/React.forwardRef(function CloudUpload16(_ref666, ref) {
  var children = _ref666.children,
      rest = _objectWithoutProperties(_ref666, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref667, _ref668, children);
});

var _ref670 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp32 = /*#__PURE__*/React.forwardRef(function CloudApp32(_ref669, ref) {
  var children = _ref669.children,
      rest = _objectWithoutProperties(_ref669, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref670, children);
});

var _ref672 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp24 = /*#__PURE__*/React.forwardRef(function CloudApp24(_ref671, ref) {
  var children = _ref671.children,
      rest = _objectWithoutProperties(_ref671, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref672, children);
});

var _ref674 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp20 = /*#__PURE__*/React.forwardRef(function CloudApp20(_ref673, ref) {
  var children = _ref673.children,
      rest = _objectWithoutProperties(_ref673, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref674, children);
});

var _ref676 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp16 = /*#__PURE__*/React.forwardRef(function CloudApp16(_ref675, ref) {
  var children = _ref675.children,
      rest = _objectWithoutProperties(_ref675, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref676, children);
});

var _ref678 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
});

var _ref679 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
});

var CloudCeiling32 = /*#__PURE__*/React.forwardRef(function CloudCeiling32(_ref677, ref) {
  var children = _ref677.children,
      rest = _objectWithoutProperties(_ref677, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref678, _ref679, children);
});

var _ref681 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
});

var _ref682 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
});

var CloudCeiling24 = /*#__PURE__*/React.forwardRef(function CloudCeiling24(_ref680, ref) {
  var children = _ref680.children,
      rest = _objectWithoutProperties(_ref680, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref681, _ref682, children);
});

export { ChartSpiral16, ChartSpiral20, ChartSpiral24, ChartSpiral32, ChartStacked16, ChartStacked20, ChartStacked24, ChartStacked32, ChartStepper16, ChartStepper20, ChartStepper24, ChartStepper32, ChartSunburst16, ChartSunburst20, ChartSunburst24, ChartSunburst32, ChartTSne16, ChartTSne20, ChartTSne24, ChartTSne32, ChartTreemap16, ChartTreemap20, ChartTreemap24, ChartTreemap32, ChartVennDiagram16, ChartVennDiagram20, ChartVennDiagram24, ChartVennDiagram32, ChartViolinPlot16, ChartViolinPlot20, ChartViolinPlot24, ChartViolinPlot32, ChartWaterfall16, ChartWaterfall20, ChartWaterfall24, ChartWaterfall32, ChartWinLoss16, ChartWinLoss20, ChartWinLoss24, ChartWinLoss32, Chat16, Chat20, Chat24, Chat32, ChatBot16, ChatBot20, ChatBot24, ChatBot32, Checkbox16, Checkbox20, Checkbox24, Checkbox32, CheckboxChecked16, CheckboxChecked20, CheckboxChecked24, CheckboxChecked32, CheckboxCheckedFilled16, CheckboxCheckedFilled20, CheckboxCheckedFilled24, CheckboxCheckedFilled32, CheckboxIndeterminate16, CheckboxIndeterminate20, CheckboxIndeterminate24, CheckboxIndeterminate32, CheckboxIndeterminateFilled16, CheckboxIndeterminateFilled20, CheckboxIndeterminateFilled24, CheckboxIndeterminateFilled32, CheckboxUndeterminate16, CheckboxUndeterminate20, CheckboxUndeterminate24, CheckboxUndeterminate32, CheckboxUndeterminateFilled16, CheckboxUndeterminateFilled20, CheckboxUndeterminateFilled24, CheckboxUndeterminateFilled32, Checkmark16, Checkmark20, Checkmark24, Checkmark32, CheckmarkFilled16, CheckmarkFilled20, CheckmarkFilled24, CheckmarkFilled32, CheckmarkFilledError16, CheckmarkFilledError20, CheckmarkFilledError24, CheckmarkFilledError32, CheckmarkFilledWarning16, CheckmarkFilledWarning20, CheckmarkFilledWarning24, CheckmarkFilledWarning32, CheckmarkOutline16, CheckmarkOutline20, CheckmarkOutline24, CheckmarkOutline32, CheckmarkOutlineError16, CheckmarkOutlineError20, CheckmarkOutlineError24, CheckmarkOutlineError32, CheckmarkOutlineWarning16, CheckmarkOutlineWarning20, CheckmarkOutlineWarning24, CheckmarkOutlineWarning32, Chemistry16, Chemistry20, Chemistry24, Chemistry32, ChemistryReference16, ChemistryReference20, ChemistryReference24, ChemistryReference32, ChevronDown16, ChevronDown20, ChevronDown24, ChevronDown32, ChevronDownGlyph, ChevronLeft16, ChevronLeft20, ChevronLeft24, ChevronLeft32, ChevronLeftGlyph, ChevronMini16, ChevronMini20, ChevronMini24, ChevronMini32, ChevronRight16, ChevronRight20, ChevronRight24, ChevronRight32, ChevronRightGlyph, ChevronSort16, ChevronSort20, ChevronSort24, ChevronSort32, ChevronSortDown16, ChevronSortDown20, ChevronSortDown24, ChevronSortDown32, ChevronSortUp16, ChevronSortUp20, ChevronSortUp24, ChevronSortUp32, ChevronUp16, ChevronUp20, ChevronUp24, ChevronUp32, ChevronUpGlyph, Chip16, Chip20, Chip24, Chip32, Choices16, Choices20, Choices24, Choices32, ChoroplethMap16, ChoroplethMap20, ChoroplethMap24, ChoroplethMap32, CircleDash16, CircleDash20, CircleDash24, CircleDash32, CircleFilled16, CircleFilled20, CircleFilled24, CircleFilled32, CirclePacking16, CirclePacking20, CirclePacking24, CirclePacking32, Classification16, Classification20, Classification24, Classification32, ClassifierLanguage16, ClassifierLanguage20, ClassifierLanguage24, ClassifierLanguage32, Clean16, Clean20, Clean24, Clean32, Close16, Close20, Close24, Close32, CloseFilled16, CloseFilled20, CloseFilled24, CloseFilled32, CloseOutline16, CloseOutline20, CloseOutline24, CloseOutline32, ClosedCaption16, ClosedCaption20, ClosedCaption24, ClosedCaption32, ClosedCaptionAlt16, ClosedCaptionAlt20, ClosedCaptionAlt24, ClosedCaptionAlt32, ClosedCaptionFilled16, ClosedCaptionFilled20, ClosedCaptionFilled24, ClosedCaptionFilled32, Cloud16, Cloud20, Cloud24, Cloud32, CloudApp16, CloudApp20, CloudApp24, CloudApp32, CloudCeiling24, CloudCeiling32, CloudDataOps16, CloudDataOps20, CloudDataOps24, CloudDataOps32, CloudDownload16, CloudDownload20, CloudDownload24, CloudDownload32, CloudLightning16, CloudLightning20, CloudLightning24, CloudLightning32, CloudRain16, CloudRain20, CloudRain24, CloudRain32, CloudSnow16, CloudSnow20, CloudSnow24, CloudSnow32, CloudUpload16, CloudUpload20, CloudUpload24, CloudUpload32, QCircuitComposer16, QCircuitComposer20, QCircuitComposer24, QCircuitComposer32, WatsonHealthCircleMeasurement16, WatsonHealthCircleMeasurement20, WatsonHealthCircleMeasurement24, WatsonHealthCircleMeasurement32 };
